module.exports = __webpack_public_path__ + "img/changwei.37c39fab.png";